import React from "react";
import { motion } from "framer-motion";

const sections = [
  {
    title: "Stress-Free, Joyful Learning",
    items: [
      "Mindful Curriculum: Balanced schedules with embedded mindfulness & yoga sessions.",
      "Safe Spaces: Counseling corners & wellness check-ins to keep you thriving.",
      "Celebration of Success: Monthly “Bright Sparks” awards and learning festivals.",
    ],
  },
  {
    title: "Creative & Experiential Learning",
    items: [
      "Maker Studios: 3D printing, electronics labs, and art-tech fusion spaces.",
      "Innovation Sprints: Hackathons, design-thinking challenges, and collaborative builds.",
      "Arts Integration: Music, drama, and visual arts woven into every subject.",
    ],
  },
  {
    title: "Communication Mastery",
    items: [
      "Interactive Debates: Structured forums to defend, persuade, and negotiate.",
      "Media Labs: Podcasting booths, video-production studios, and digital storytelling.",
      "Language Clubs: From English eloquence to Mandarin mastery—speak like a global citizen.",
    ],
  },
  {
    title: "Activity-Based & Self-Directed Learning",
    items: [
      "Learning Path Builder: Choose modules, set goals, and track progress in real time.",
      "Peer Study Hubs: Team up, solve problems, and learn faster in our facilitated group study sessions.",
      "Self-Learning Portfolios: Curate projects, experiments, and reflections for lifelong growth.",
    ],
  },
  {
    title: "Proven IIT-JEE & NEET Excellence",
    items: [
      "Expert Mentorship: Learn from faculty with years of coaching toppers.",
      "Targeted Practice: Adaptive mock tests & personalized feedback loops.",
      "Concept-First Learning: Strengthen core fundamentals to tackle any challenge with confidence.",
    ],
  },
  {
    title: "Pathways to Top International Universities",
    items: [
      "Holistic Profile Building: Community service, research projects, and leadership roles.",
      "Guided Applications: One-on-one counselling for SAT, IELTS/TOEFL, and essay writing.",
      "Alumni Network: Connect with Rankridge graduates at Harvard, Cambridge, and more.",
    ],
  },
  {
    title: "Leadership & Life-Skills Development",
    items: [
      "Executive Workshops: Public speaking, negotiation, and critical decision-making.",
      "From Theory to Impact: Students shape global policy in Model UN, launch the next big idea in our Startup Launchpad, and pioneer real-world solutions in our Civic Innovation Lab.",
    ],
  },
];


export default function RankridgeLanding() {
  return (
    <div className="min-h-screen bg-[#20b2aa] flex items-center justify-center py-12 px-4">
      <div className="max-w-4xl w-full space-y-12">
        {sections.map((section, idx) => (
          <motion.div
            key={idx}
            initial={{ opacity: 0, x: -50 }}
            animate={{ opacity: 1, x: 0 }}
            transition={{ delay: idx * 0.2, duration: 0.6 }}
            className="bg-white bg-opacity-80 backdrop-blur-lg rounded-2xl p-8 shadow-lg"
          >
            <h2 className="text-2xl font-extrabold text-green-900 mb-4">
              {section.title.split("\n").map((line, index) => (
                <span key={index}>
                  {line}
                  <br />
                </span>
              ))}
            </h2>
            <ul className="list-disc list-inside space-y-2 text-gray-700 text-left">
              {section.items.map((item, i) => (
                <li key={i}>{item}</li>
              ))}
            </ul>
          </motion.div>
        ))}
      </div>
    </div>
  );
}
